import "./src/styles/global.css";
import "./src/styles/prism-theme.css";
import "typeface-oswald";
import "typeface-crimson-text";
import "typeface-nunito-sans";
